import React, { FC, Fragment, useContext } from 'react'
import './recap-pallet.scss'
import { StopEquipment } from 'services/types'
import { TripContext } from 'contexts'
import { PalletsRegular } from 'services/types/equipments'

type Props = {
    stopId: number | undefined
}

export const RecapPallet: FC<Props> = ({ stopId }) => {

    const tripContext = useContext(TripContext)
    const stopEquipments: StopEquipment[] = tripContext.stopEquipments.filter(equipment => equipment.stopId === stopId) ?? []
    const palletsRegular: StopEquipment = stopEquipments.find(equipment => equipment.equipmentTypeId === PalletsRegular.Id) ?? {} as StopEquipment

    return (
        <Fragment>
            <div className={'recap-pallet-heading'}>
                <div className={'recap-pallet-subheading'}> Regular Pallets </div>
            </div>
            <div className={'recap-pallet-details'}>
                <div className={'recap-pallet-container'}>In : {palletsRegular.quantityIn ?? '0'}</div>
                <div className={'recap-pallet-container'}>Rtn : {palletsRegular.quantityOut ?? '0'}</div>
            </div>
        </Fragment>
    )
}
